import { CustomerNumber } from 'src/types';

class EventTracker {
    static setVisitorId(visitorId: string) {
        window.pendoVisitorId = visitorId;
    }

    static identifyUser(
        user: { uuid: string; firstName?: string; lastName?: string; email?: string },
        activeCustomerNumber: CustomerNumber,
        totalNumberOfAccounts: number,
        requestId?: string | null,
        requestType?: string,
    ) {
        if (window.pendo) {
            const visitorData = {
                id: user.uuid,
                name: activeCustomerNumber.usedByName,
                usedByEmail: activeCustomerNumber.usedByEmail,
                usedByDesc: activeCustomerNumber.usedByDesc,
                environment: process.env.REACT_APP_ENV,
                totalNumberOfAccounts,
            };

            const accountData: Record<string, any> = {
                id: activeCustomerNumber.number,
                number: activeCustomerNumber.number,
                minsPaid: activeCustomerNumber.minsPaid,
                ownedByType: activeCustomerNumber.ownedByType,
                ownedByName: activeCustomerNumber.ownedByName,
                ownedByDesc: activeCustomerNumber.ownedByDesc,
                ownedByEmail: activeCustomerNumber.ownedByEmail,
                numberTypeId: activeCustomerNumber.numberTypeId,
                creditType: activeCustomerNumber.creditType,
            };

            if (requestId !== undefined) {
                accountData.requestId = requestId;
            }

            if (requestType) {
                accountData.requestType = requestType;
            }

            window.pendo.identify({
                visitor: visitorData,
                account: accountData,
            });
        } else {
            console.warn('Pendo is not initialized');
        }
    }

    static handleUserIdentification(
        user: { uuid: string; firstName?: string; lastName?: string },
        activeCustomerNumber: CustomerNumber,
        totalNumberOfAccounts: number,
    ) {
        this.setVisitorId(user.uuid);
        if (window.pendoVisitorId) {
            try {
                this.identifyUser(user, activeCustomerNumber, totalNumberOfAccounts);
            } catch (error) {
                console.error('Error identifying Pendo user:', error);
            }
        }
    }

    static setAccountData(
        user: { uuid: string; firstName?: string; lastName?: string; email?: string },
        activeCustomerNumber: CustomerNumber,
        totalNumberOfAccounts: number,
        requestId: string | null,
        requestType?: string,
    ) {
        this.identifyUser(
            user,
            activeCustomerNumber,
            totalNumberOfAccounts,
            requestId ?? null,
            requestType,
        );
    }

    static trackEvent(eventName: string, eventData: Record<string, any>) {
        if (window.pendo) {
            window.pendo.track(eventName, eventData);
        } else {
            console.warn('Pendo is not initialized');
        }
    }
}
export default EventTracker;
